import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can use the `}<a parentName="p" {...{
        "href": "/docs/libraries/js/features#amending-or-sampling-events"
      }}><inlineCode parentName="a">{`before_send`}</inlineCode></a>{` callback in the `}<a parentName="p" {...{
        "href": "/docs/libraries/js"
      }}>{`web`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/libraries/node"
      }}>{`Node.js`}</a>{` SDKs to exclude any exception events you do not wish to capture. Do this by providing a `}<inlineCode parentName="p">{`before_send`}</inlineCode>{` function when initializing PostHog and have it return a falsey value for any events you want to drop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`posthog.init('<ph_project_api_key>', {
    before_send: (event) => {
        if (event.event === "$exception") {
            const exceptionList = event.properties["$exception_list"] || []
            const exception = exceptionList.length > 0 ? exceptionList[0] : null;

            if (exception && exception["$exception_type"] === "UnwantedError") {
                return false
            }
        }
        return event
    }
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      